var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.checkEdit)?_c('div',[_c('img',{staticStyle:{"cursor":"pointer"},attrs:{"src":require("@/assets/edit_pencil.svg")},on:{"click":function($event){return _vm.gotoDetail()}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }